import { render, staticRenderFns } from "./Qa.vue?vue&type=template&id=3a891c0c&scoped=true&"
import script from "./Qa.vue?vue&type=script&lang=js&"
export * from "./Qa.vue?vue&type=script&lang=js&"
import style0 from "./Qa.vue?vue&type=style&index=0&id=3a891c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a891c0c",
  null
  
)

export default component.exports